import React, { useEffect, useState, useRef, useCallback, memo } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import "../../../styles/Auth/customer.css";
import { getData, uploadFile, postData, putData, deleteData } from "../../../webService/webservice.js"
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import trayUpload from "@iconify/icons-mdi/tray-upload";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import MembershipMultiSelectAsync from "../../Challange/MemberShipMultiSelect.jsx";
import TVFMLoader from "../Loader/loader.jsx";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Box,
    Modal,
    Button,
    Tooltip,
    Menu,
    MenuItem
} from '@mui/material';
import { useStore } from "../../../Context/context.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import Footer from "../Footer/Footer-page.jsx";
const ALL_MODE_PAGE_SIZE = 100;

const rowCellStyle = {
    color: '#525252',
    fontSize: '12px',
    fontWeight: 600,
    textAlign: 'center'
};

const getCustomerImageSrc = (customer) => {
    const uri = customer.customerImageObject?.uri;
    if (!uri) return "/assets/mdi--user.svg";
    return uri.startsWith("/assets") ? uri : `${process.env.REACT_APP_API_URL}${uri}`;
};

// One table row. Memoized: it only re-renders when its own customer data changes.
const CustomerRow = memo(function CustomerRow({ customer, serialNo, canDelete, onView, onEdit, onDelete }) {
    const isMember = customer.subscriptionIds && customer.subscriptionIds.length > 0;
    return (
        <TableRow>
            <TableCell>{serialNo}</TableCell>

            <TableCell>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <img
                        src={getCustomerImageSrc(customer)}
                        alt="Customer"
                        loading="lazy"
                        decoding="async"
                        style={{ width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover' }}
                    />
                </Box>
            </TableCell>

            <TableCell><Typography sx={rowCellStyle}>{customer.name}</Typography></TableCell>
            <TableCell><Typography sx={rowCellStyle}>{customer.phoneNumber}</Typography></TableCell>
            <TableCell><Typography sx={rowCellStyle}>{customer.aboutUs}</Typography></TableCell>
            <TableCell align="center">
                <Typography sx={{
                    color: '#ffffff !important',
                    backgroundColor: isMember ? '#3C0008' : '#8A8A8A',
                    border: 'none',
                    padding: '6px 12px',
                    borderRadius: '20px',
                    fontSize: '11px',
                    fontWeight: 600,
                    display: 'inline-block',
                    whiteSpace: 'nowrap'
                }}>
                    {isMember ? 'Member Customer' : 'Non Member Customer'}
                </Typography>
            </TableCell>
            <TableCell><Typography sx={rowCellStyle}>{customer.totalBookings}</Typography></TableCell>

            <TableCell>
                {customer.isActive ? (
                    <p className="stat-value">
                        {customer.createdAt ? new Date(customer.createdAt).toLocaleDateString("en-GB") : "-"}
                    </p>
                ) : (
                    <>
                        <p className="stat-label">Last Visited</p>
                        <p className="stat-value">
                            {customer.lastVisitedDate
                                ? new Date(customer.lastVisitedDate).toLocaleDateString('en-GB')
                                : "N/A"}
                        </p>
                    </>
                )}
            </TableCell>
            <TableCell>
                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                    <Tooltip title="View Customer">
                        <Icon
                            icon={plusIcon}
                            width={20}
                            height={20}
                            style={{ cursor: "pointer" }}
                            onClick={() => onView(customer._id)}
                        />
                    </Tooltip>
                    <Tooltip title="Edit Customer">
                        <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => onEdit(customer)} />
                    </Tooltip>
                    {canDelete && (
                        <Tooltip title="Delete Customer">
                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: "pointer" }}
                                onClick={() => onDelete(customer._id)}
                            />
                        </Tooltip>
                    )}
                </Box>
            </TableCell>
        </TableRow>
    );
});

const CustomerPage = () => {
    const headings = [
        'S.NO',
        'Image',
        'Customer Name',
        'Mobile Number',
        'Profession',
        'Customer Type',
        'Total Bookings',
        'Since',
        'Action',
    ];
    const maleImage = "/assets/male-sample.png";
    const femaleImage = "/assets/female.jpeg";
    const defaultImage = "/assets/mdi--user.svg";

    const fileInputRef = useRef(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(null);
    const isActionMenuOpen = Boolean(actionAnchorEl);
    const handleActionClick = (event) => {
        setActionAnchorEl(event.currentTarget);
    };
    const handleActionClose = () => {
        setActionAnchorEl(null);
    };
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const navigate = useNavigate();
    const location = useLocation();
    const isAddCustomer = location.pathname === '/customers/add';
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [customerImage, setCustomerImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(defaultImage);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [totalMembersCount, setTotalMembersCount] = useState(0);
    const [totalNonMembersCount, setTotalNonMembersCount] = useState(0);
    const [emailError, setEmailError] = useState("");
    const [stateError, setStateError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [cityError, setCityError] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchQuery);
            setCurrentPage(1);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchQuery]);
    const sessionToken = localStorage.getItem("Token");
    const [stores, setStores] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editCustomerId, setEditCustomerId] = useState([]);
    const [limit, setLimit] = useState(5);
    const [refreshKey, setRefreshKey] = useState(0);
    const [CustomersToDelete, setCustomersToDelete] = useState(null);
    const [open, setOpen] = useState();
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [fileName, setFileName] = useState("");
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [Store, setStore] = useState(ALL_STORE_OPTION);
    const sort = [[sortField, sortOrder]];

    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [showLoader, setShowLoader] = useState(false);
    const [isAddStore, setIsAddStore] = useState(false);
    const [LoaderText, setLoaderText] = useState('');
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [formData, setFormData] = useState({
        storeId: initialStoreId,
        name: '',
        email: '',
        gender: '',
        phoneNumber: '',
        country: 'India',
        city: '',
        state: '',
        pincode: '',
        age: '',
        customerImageObject: '',
        aboutUs: '',
        customerNote: '',
        subscriptionIds: [],
        storeName: "", // Initialize storeName
        dateOfBirth: '',
        aniversaryDate: ''
    });

    useEffect(() => {
        const fetchStoreName = async () => {
            // Handle single storeId
            if (formData.storeId && !formData.storeName) {
                try {
                    const res = await getData(`stores/store/${formData.storeId}`, {}, sessionToken);
                    if (res?.data) {
                        setFormData(prev => ({
                            ...prev,
                            storeName: res.data.storeName
                        }));
                    }
                } catch (err) {
                    console.error("Failed to fetch store name", err);
                }
            }
        };
        fetchStoreName();
    }, [formData.storeId, formData.storeName]);

    const EMPTY_ARRAY = [];

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };
    const [errors, setErrors] = useState({
        name: "",
        phoneNumber: "",
        gender: ""
    });
    const [storeRefreshKey, setStoreRefreshKey] = useState(0);
    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    useEffect(() => {
        if (isEditMode) {
            const fetchCustomer = async () => {
                try {
                    const token = localStorage.getItem("Token");
                    const response = await getData(`customers/customer/${editCustomerId}`, token);

                    const data = Array.isArray(response.data)
                        ? response.data[0]
                        : response.data;

                    setFormData({
                        name: data?.name || "",
                        phoneNumber: data?.phoneNumber || "",
                        email: data?.email || "",
                        age: data?.age || "",
                        gender: data?.gender || "",
                        city: data?.city || "",
                        country: data?.country || "",
                        state: data?.state || "",
                        pincode: data?.pincode || "",
                        storeId: data?.storeId?._id || data?.storeId || "",
                        storeName: data?.storeId?.storeName || "", // ✅ Added storeName
                        customerImageObject: data?.customerImageObject || "",
                        subscriptionIds: data?.subscriptionIds || [],
                        aboutUs: data?.aboutUs || "",
                        customerNote: data?.customerNote || "",
                        dateOfBirth: data?.dateOfBirth ? new Date(data.dateOfBirth).toISOString().split('T')[0] : "",
                        aniversaryDate: data?.aniversaryDate ? new Date(data.aniversaryDate).toISOString().split('T')[0] : ""
                    });

                    setPreviewUrl(
                        data?.customerImageObject?.uri
                            ? `${process.env.REACT_APP_API_URL}${data.customerImageObject.uri}`
                            : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                    );
                } catch (error) {
                    console.error("Error fetching customer:", error);
                }
            };

            fetchCustomer();
        }
    }, [isEditMode, editCustomerId]);


    useEffect(() => {
        console.log("formData", formData);
    }, [formData]);

    const validateEmail = (email) => {
        // Basic RFC 5322 official email regex simplified
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleEmailChange = (e) => {
        const email = e.target.value;
        setFormData((prev) => ({ ...prev, email }));

        if (!validateEmail(email)) {
            setEmailError("Please enter a valid email address");
        } else {
            setEmailError("");
        }
    };

    // Allow only digits and max length 6 for pincode
    const handlePincodeInput = (e) => {
        const value = e.target.value;
        if (/^\d{0,6}$/.test(value)) {
            setFormData((prev) => ({ ...prev, pincode: value }));
        }
    };

    // Optional: Validate pincode length on blur
    const handlePincodeBlur = () => {
        if (formData.pincode && formData.pincode.length !== 6) {
            alert("Pincode must be exactly 6 digits");
        }
    };

    const handleAlphabeticInput = (e, fieldName) => {
        const value = e.target.value;
        if (/^[a-zA-Z\s]*$/.test(value)) {
            setFormData((prev) => ({ ...prev, [fieldName]: value }));
            if (fieldName === "city") setCityError("");
            if (fieldName === "country") setCountryError("");
            if (fieldName === "state") setStateError("");
        } else {
            if (fieldName === "city") setCityError("Only letters and spaces allowed");
            if (fieldName === "country") setCountryError("Only letters and spaces allowed");
            if (fieldName === "state") setStateError("Only letters and spaces allowed");
        }
    };

    const handleAddCustomer = async (e) => {
        e.preventDefault();
        if (!validateCustomerForm()) return;

        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let uploadedImageObject = null;

            // ✅ 1️⃣ Image upload (optional)
            if (customerImage && userId) {
                const uploadResult = await uploadFile(
                    `files/upload/${userId}`,
                    customerImage
                );

                if (uploadResult?.status === 200) {
                    uploadedImageObject = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    return;
                }
            }

            const subscriptionIds = formData.selectedMemberships || [];

            // ✅ 2️⃣ FINAL IMAGE DECISION ✅✅✅ (MAIN FIX)
            let finalImageObject = null;

            if (uploadedImageObject) {
                // ✅ User uploaded image
                finalImageObject = uploadedImageObject;
            } else {
                // ✅ No upload → use gender image
                if (formData.gender === "male") {
                    finalImageObject = { imageUrl: maleImage };
                } else if (formData.gender === "female") {
                    finalImageObject = { imageUrl: femaleImage };
                } else {
                    finalImageObject = { imageUrl: defaultImage };
                }
            }

            // ✅ 3️⃣ FINAL CUSTOMER DATA
            const customerData = {
                name: formData.name,
                email: formData.email,
                gender: formData.gender,
                phoneNumber: formData.phoneNumber,
                country: formData.country,
                city: formData.city,
                state: formData.state,
                pincode: formData.pincode,
                storeId: formData.storeId,
                age: formData.age,
                aboutUs: formData.aboutUs,
                customerNote: formData.customerNote,

                // ✅✅ CORRECT IMAGE ALWAYS SENT NOW
                customerImageObject: finalImageObject,

                subscriptionIds,
                dateOfBirth: formData.dateOfBirth || null,
                aniversaryDate: formData.aniversaryDate || null
            };

            console.log("✅ Sending FINAL customer data:", customerData);

            const response = await postData("customers/", customerData, token);

            if (response?.success === false) {
                throw new Error(response.message || "Failed to add customer");
            }

            toast.success(response.message || "Customer added successfully");

            // ✅ 4️⃣ RESET FORM
            setFormData({
                customerName: "",
                storeId: selectedStoreId || initialStoreId,
                storeName: "",
                name: "",
                email: "",
                gender: "",
                phoneNumber: "",
                country: "",
                city: "",
                state: "",
                pincode: "",
                aboutUs: "",
                customerNote: "",
                customerImageObject: "",
                age: "",
                selectedMemberships: [],
                membershipNames: {},
                memberShipPrices: [],
                dateOfBirth: "",
                aniversaryDate: ""
            });

            setCustomerImage(null);
            setPreviewUrl(defaultImage);
            navigate("/customers");
            triggerRefresh(); // reloads the list

        } catch (error) {

            console.error("Add Customer Error:", error);

            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Add Customer Failed";

            toast.error(errorMessage);
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 2000);
        }
    };




    // const handleAddCustomer = async (e) => {
    //     e.preventDefault();
    //     if (!validateCustomerForm()) return;
    //     try {
    //         const token = localStorage.getItem("Token");
    //         const userId = localStorage.getItem("userId");
    //         if (customerImage && userId) {
    //             const uploadResult = await uploadFile(`files/upload/${userId}`, customerImage);

    //             if (uploadResult?.status === 200) {
    //                 // Build the full image URL
    //                 const customerData = {
    //                     name: formData.name,
    //                     email: formData.email,
    //                     gender: formData.gender,
    //                     phoneNumber: formData.phoneNumber,
    //                     country: formData.country,
    //                     city: formData.city,
    //                     state: formData.state,
    //                     pincode: formData.pincode,
    //                     customerImageObject: uploadResult?.data,
    //                     storeId: formData.storeId,
    //                     age: formData.age
    //                 };
    //                 console.log("Sending customer data:", customerData);

    //                 const response = await postData('customers/', customerData, token);

    //                 toast.success(response.message || 'Customer added successfully');
    //                 setFormData({
    //                     customerName: '',
    //                     storeId: '',
    //                     name: '',
    //                     email: '',
    //                     gender: '',
    //                     phoneNumber: '',
    //                     country: '',
    //                     city: '',
    //                     state: '',
    //                     pincode: '',
    //                     customerImageObject: '',
    //                     age: ''
    //                 });
    //                 setCustomerImage(null);
    //                 setPreviewUrl(null);
    //                 navigate("/customers");
    //                 triggerRefresh();
    //                 setLoading(true);
    //             } else {
    //                 toast.error(uploadResult?.message || "Image upload failed");
    //             }
    //         }
    //     } catch (error) {
    //         console.error('Add Customer Error:', error);
    //         toast.error(error.message || 'Add Customer Failed');
    //     }
    // };

    const handleUpdateCustomer = async (e) => {
        e.preventDefault();

        setShowLoader(true);
        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let updatedImageObject = null;

            // ✅ 1️⃣ If user selected NEW file → upload
            if (customerImage && userId) {
                const uploadResult = await uploadFile(
                    `files/upload/${userId}`,
                    customerImage
                );

                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedImageObject = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    return;
                }
            }
            // ✅ 2️⃣ If NO upload → decide from gender OR keep existing
            else {
                if (formData.gender === "male") {
                    updatedImageObject = { imageUrl: maleImage };
                } else if (formData.gender === "female") {
                    updatedImageObject = { imageUrl: femaleImage };
                } else if (formData.customerImageObject) {
                    // ✅ keep old image if gender not changed
                    updatedImageObject = formData.customerImageObject;
                } else {
                    updatedImageObject = { imageUrl: defaultImage };
                }
            }

            const updatedCustomerData = {
                storeId: formData.storeId,
                name: formData.name,
                email: formData.email,
                gender: formData.gender,
                phoneNumber: formData.phoneNumber,
                country: formData.country,
                city: formData.city,
                state: formData.state,
                pincode: formData.pincode,
                age: formData.age,

                // ✅✅ ALWAYS CORRECT IMAGE NOW
                customerImageObject: updatedImageObject,

                aboutUs: formData.aboutUs,
                customerNote: formData.customerNote,
                subscriptionIds: formData.subscriptionIds || [],
                dateOfBirth: formData.dateOfBirth || null,
                aniversaryDate: formData.aniversaryDate || null
            };

            console.log("✅ Updating Customer with data:", updatedCustomerData);

            const response = await putData(
                `customers/customer/${editCustomerId}`,
                updatedCustomerData,
                token
            );

            if (response?.success === false) {
                throw new Error(response.message || "Failed to update customer");
            }

            toast.success(response.message || "Customer updated successfully");

            // ✅ RESET FORM
            setFormData({
                storeId: selectedStoreId || initialStoreId,
                storeName: "",
                name: "",
                email: "",
                gender: "",
                phoneNumber: "",
                country: "",
                city: "",
                state: "",
                pincode: "",
                customerImageObject: null,
                age: "",
                aboutUs: "",
                customerNote: "",
                subscriptionIds: "",
                dateOfBirth: "",
                aniversaryDate: ""
            });

            setCustomerImage(null);
            setPreviewUrl(null);
            triggerRefresh();
            setIsPopupMode(false);
            navigate("/customers");

        } catch (error) {
            console.error("Update Customer Error:", error);
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Error updating customer";
            toast.error(errorMessage);
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 2000);
        }
    };



    // "All" no longer loads every customer at once (thousands of rows froze the browser).
    // It loads ALL_MODE_PAGE_SIZE rows at a time and fetches the next batch as the user scrolls.
    const isAllMode = limit === "all";
    const requestIdRef = useRef(0);          // ignore responses from outdated requests
    const allModePageRef = useRef(1);        // last page loaded in "All" mode
    const [loadingMore, setLoadingMore] = useState(false);
    const tableContainerRef = useRef(null);
    const loadMoreSentinelRef = useRef(null);

    const buildCustomerParams = (page, pageLimit) => {
        const search = debouncedSearch?.trim() || "";
        const params = {
            page,
            limit: pageLimit,
            name: search,
            phoneNumber: search,
            email: search,
            // _id keeps the order stable when names/dates tie, so pages never repeat or skip rows
            sort: JSON.stringify([[sortField, sortOrder], ["_id", sortOrder]])
        };
        const sid = ["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) ? Store?.value : Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }
        return params;
    };

    const fetchCustomers = async ({ append = false } = {}) => {
        const requestId = ++requestIdRef.current;
        const page = isAllMode ? (append ? allModePageRef.current + 1 : 1) : currentPage;
        const params = buildCustomerParams(page, isAllMode ? ALL_MODE_PAGE_SIZE : limit);

        try {
            if (append) setLoadingMore(true);
            else setLoading(true);

            const response = await getData('customers/customers', params, sessionToken);
            if (requestId !== requestIdRef.current) return;

            if (response?.status !== 200) {
                toast.error(response?.message || "Failed to fetch customers");
                return;
            }
            const resultsWrapper = response?.data?.[0];
            const customersList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;
            const members = resultsWrapper?.membersCount ?? customersList.filter(c => c.subscriptionIds && c.subscriptionIds.length > 0).length;
            const nonMembers = resultsWrapper?.nonMembersCount ?? Math.max(0, totalCount - members);

            if (append) {
                setCustomers(prev => {
                    const seen = new Set(prev.map(c => c._id));
                    return [...prev, ...customersList.filter(c => !seen.has(c._id))];
                });
            } else {
                setCustomers(customersList);
                if (tableContainerRef.current) tableContainerRef.current.scrollTop = 0;
            }
            if (isAllMode) allModePageRef.current = page;
            setTotalCount(totalCount);
            setTotalPages(isAllMode ? 1 : totalPages);
            setTotalMembersCount(members);
            setTotalNonMembersCount(nonMembers);
        } catch (error) {
            if (requestId !== requestIdRef.current) return;
            console.error("Failed to load customers", error);
            toast.error(error?.message || "Failed to load customers");
        } finally {
            if (requestId === requestIdRef.current) {
                setLoading(false);
                setLoadingMore(false);
            }
        }
    };

    // Stable row handlers so memoized rows don't re-render on unrelated state changes
    const handleViewCustomer = useCallback((customerId) => {
        navigate(`/customers/customer/${customerId}`);
    }, [navigate]);

    const handleEditCustomer = useCallback((customer) => {
        setFormData({
            name: customer.name || '',
            phoneNumber: customer.phoneNumber || '',
            storeId: customer.storeId?._id || customer.storeId || "",
            storeName: customer.storeId?.storeName || "",
            email: customer.email || '',
            age: customer.age || "",
            city: customer.city || '',
            country: customer.country || '',
            state: customer.state || '',
            pincode: customer.pincode || '',
            subscriptionIds: customer.subscriptionIds || '',
            aboutUs: customer.aboutUs || '',
            customerNote: customer.customerNote || '',
            customerImageObject: customer.customerImageObject || null,
            dateOfBirth: customer.dateOfBirth ? new Date(customer.dateOfBirth).toISOString().split('T')[0] : "",
            aniversaryDate: customer.aniversaryDate ? new Date(customer.aniversaryDate).toISOString().split('T')[0] : ""
        });
        setPreviewUrl(
            customer?.customerImageObject?.uri
                ? customer.customerImageObject.uri.startsWith("/assets")
                    ? customer.customerImageObject.uri // ✅ Male/Female image
                    : `${process.env.REACT_APP_API_URL}${customer.customerImageObject.uri}` // ✅ Uploaded image
                : "/assets/mdi--user.svg"
        );

        setCustomerImage(null);
        setEditCustomerId(customer._id);
        setIsPopupMode(true);
        setIsEditMode(true);
        setLoaderText("Updating Customer...");
    }, []);

    useEffect(() => {
        fetchCustomers();
    }, [currentPage, limit, refreshKey, debouncedSearch, selectedStoreId, sortField, sortOrder, Store]);

    const hasMoreCustomers = isAllMode && customers.length < totalCount;

    // Load the next batch when the bottom of the table scrolls into view
    useEffect(() => {
        const sentinel = loadMoreSentinelRef.current;
        if (!hasMoreCustomers || loading || loadingMore || !sentinel) return;
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0]?.isIntersecting) fetchCustomers({ append: true });
            },
            { root: tableContainerRef.current, rootMargin: "200px" }
        );
        observer.observe(sentinel);
        return () => observer.disconnect();
    }, [hasMoreCustomers, loading, loadingMore, customers.length]);

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.results || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };
        fetchStores();
    }, []);

    useEffect(() => {
        const storedStoreId = localStorage.getItem("storeId");
        if (storedStoreId && stores.length > 0) {
            const matchedStore = stores.find((store) => store._id === storedStoreId);
            if (matchedStore) {
                setFormData((prev) => ({
                    ...prev,
                    storeId: matchedStore._id,
                    storeName: matchedStore.storeName,
                }));
            }
        }
    }, [stores]);

    const validateCustomerForm = () => {
        let newErrors = { name: "", phoneNumber: "", gender: "" };
        let isValid = true;

        if (!formData.name || formData.name.trim() === "") {
            newErrors.name = "Name is required";
            isValid = false;
        } else {
            if (formData.name.trim().length < 3) {
                newErrors.name = "Name must be at least 3 characters";
                isValid = false;
            } else if (!/^[A-Za-z ]+$/.test(formData.name.trim())) {
                newErrors.name = "Name should contain only alphabets";
                isValid = false;
            }
        }

        if (!formData.phoneNumber || formData.phoneNumber === "") {
            newErrors.phoneNumber = "Mobile Number is required";
            isValid = false;
        } else {
            if (!/^\d{10}$/.test(formData.phoneNumber)) {
                newErrors.phoneNumber = "Mobile Number must be exactly 10 digits";
                isValid = false;
            }
        }

        if (!formData.gender || formData.gender === "") {
            newErrors.gender = "Gender is required";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const val = e.target.value;
        const newLimit = val === "all" ? "all" : Number(val);
        setLimit(newLimit);
        setCurrentPage(1);
    };


    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };
        setLoading(true);
        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const sampleServiceData = [
        {
            name: "Priya Sharma",
            email: "priya.sharma@example.com",
            phoneNumber: "9812345678",
            address: "45, MG Road, Indira Nagar",
            age: "28",
            country: "India",
            city: "Bengaluru",
            state: "Karnataka",
            gender: "female",
            pincode: "560038",
            customerNote: "Sample Note",
            dateOfBirth: "1998-05-20",
            aniversaryDate: "2024-11-28"
        }]

    const handleExportExcel = () => {
        // Create a new workbook and worksheet
        const worksheet = XLSX.utils.json_to_sheet(sampleServiceData);

        // Format only the first header row (row 1) with bold font and background color
        const range = XLSX.utils.decode_range(worksheet["!ref"] || "A1:L2");
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = {
                    font: { bold: true, color: { rgb: "000000" } },
                    fill: { fgColor: { rgb: "D9E1F2" }, patternType: "solid" },
                    alignment: { horizontal: "center", vertical: "center" }
                };
            }
        }

        // Ensure no worksheet protection or cell locking exists
        delete worksheet["!protect"];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

        // Download Excel file
        XLSX.writeFile(workbook, "Customers.xlsx");
    };
    useEffect(() => {
        // stores = array of store objects you already load for dropdown
        if (stores && stores.length === 1) {
            const onlyStore = stores[0]._id;
            setSelectedStoreId(onlyStore);
            console.log("✔ Auto-selected store because only one store exists:", onlyStore);
        }
    }, [stores]);

    const handleBulkUploadClick = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setShowLoader(true);
        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            // Priority: Use the store selected in the dropdown for Admins, or global context for others.
            const sid = (["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role))
                ? Store?.value
                : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

            const storeIdToUse =
                sid ||
                (stores?.length === 1 ? stores[0]._id : null);

            if (!storeIdToUse) {
                alert("Please select a store before uploading");
                return;
            }

            const formData = new FormData();
            formData.append("file", file);

            // ✅ DROPDOWN STORE FOR ALL CUSTOMERS
            formData.append("storeIds", storeIdToUse);

            console.log("✅ Customer Bulk Upload - Selected Store:", storeIdToUse);

            const response = await postData(
                `/customers/bulkupload/${userId}`,
                formData,
                token,
                true
            );

            if (e.target) e.target.value = "";

            if (!response || response.success === false || response.status === 400 || response.status === 500 || response.status === 403) {
                toast.error(response?.message || "Error uploading customers!");
                setShowLoader(false);
                return;
            }

            toast.success(response?.message || "Bulk Upload Successful!");
            console.log("Upload Response:", response);
            navigate("/customers");
            triggerRefresh();

        } catch (error) {
            console.error("Bulk Upload Failed:", error);
            toast.error(error?.message || "Error uploading customers!");
        } finally {
            setShowLoader(false);
        }
    };

    const indianStates = [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Andaman and Nicobar Islands",
        "Chandigarh",
        "Dadra & Nagar Haveli and Daman & Diu",
        "Delhi",
        "Jammu & Kashmir",
        "Ladakh",
        "Lakshadweep",
        "Puducherry"
    ];

    const handleExportExcelCustomerData = async () => {

        // In "All" mode only part of the list is loaded on screen, so fetch the full list for the file
        let exportCustomers = customers;
        if (isAllMode && customers.length < totalCount) {
            try {
                setLoaderText("Preparing export...");
                setShowLoader(true);
                const response = await getData('customers/customers', buildCustomerParams(1, "all"), sessionToken);
                exportCustomers = response?.data?.[0]?.paginatedResults || [];
            } catch (error) {
                console.error("Export fetch failed", error);
                return toast.error("Failed to fetch customers for export");
            } finally {
                setShowLoader(false);
            }
        }

        if (!exportCustomers || exportCustomers.length === 0) {
            return toast.error("No data available to export");
        }

        // Map data to show names instead of IDs
        const exportData = exportCustomers.map(customer => ({
            "Customer Name": customer.name,
            "Store Name": customer.storeDetails?.storeName,
            "Email": customer.email,
            "Mobile Number": customer.phoneNumber,
            "Customer Type": customer.subscriptionIds && customer.subscriptionIds.length > 0 ? "Member Customer" : "Non Member Customer",
            "Gender": customer.gender,
            "Age": customer.age,
            "City": customer.city,
            "State": customer.state,
            "Country": customer.country,
            "Pincode": customer.pincode,
            "Customer Note": customer.customerNote || "",
            "Date of Birth": customer.dateOfBirth ? new Date(customer.dateOfBirth).toLocaleDateString("en-GB") : "",
            "Anniversary Date": customer.aniversaryDate ? new Date(customer.aniversaryDate).toLocaleDateString("en-GB") : "",
            "Total Bookings": customer.totalBookings,
            "Joined Date": customer.createdAt ? new Date(customer.createdAt).toLocaleDateString("en-GB") : ""
        }));

        // Convert to worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

        // Convert to Excel buffer
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        // Create Blob
        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(data, `customers-${Date.now()}.xlsx`);
    };

    const handleOpen = useCallback((customerId) => {
        setCustomersToDelete(customerId);
        setOpen(true);
    }, []);

    const handleClose = () => {
        setOpen(false);
        setCustomersToDelete(null);
    };

    const handleDeleteCustomer = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`customers/customer/${CustomersToDelete}`, token);
            toast.success(response.message || "Customer deleted successfully");
            setCustomersToDelete(null);
            handleClose();
            triggerRefresh(); // reloads the list
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Customer");
        }
    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    return (
        <div className="product-layout">
            <div className="product-content">
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-loader">
                            <TVFMLoader />
                        </div>
                    </div>
                )}
                <main className="product-main">
                    {isAddCustomer ? (
                        /* ================= ADD / EDIT CUSTOMER FORM ================= */
                        <div className="add-customer-form">
                            <Typography variant="h6" mb={2}>Add Customer</Typography>
                            <form className="customer-form">
                                <div className="customer-form-row">
                                    <div className="customer-form-group-image">
                                        <div className="image-upload-wrapper">
                                            <div className="image-placeholder">
                                                <img
                                                    src={previewUrl || defaultImage}
                                                    alt="Preview"
                                                    className="round-image"
                                                />
                                            </div>
                                        </div>
                                        <div className="upload-icon-container">
                                            <label htmlFor="customerImage" className="upload-icon-btn">
                                                Upload Image
                                                <Icon icon={trayUpload} width="24" height="24" />
                                                <input
                                                    type="file"
                                                    id="customerImage"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file && file.size > 1024 * 1024) {
                                                            toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                                            e.target.value = "";
                                                            return;
                                                        }
                                                        if (file) {
                                                            setCustomerImage(file);
                                                            setPreviewUrl(URL.createObjectURL(file)); // ✅ MANUAL IMAGE OVERRIDES GENDER
                                                        }
                                                    }}
                                                />

                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="customer-form-row">
                                    <div className="customer-form-group">
                                        <label htmlFor="name" className="input-label">
                                            Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter customer name"
                                            className="category-input"
                                            value={formData.name}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                            }
                                        />
                                        {errors.name && <p className="field-error">{errors.name}</p>}
                                    </div>
                                    <div className="customer-form-group">
                                        <label className="input-label">Store Name</label>
                                        <StoreMultiSelect
                                            value={
                                                formData.storeId
                                                    ? [{
                                                        value: formData.storeId,
                                                        label: formData.storeName
                                                    }]
                                                    : []
                                            }
                                            onChange={(val) => {
                                                // ❌ Prevent clearing if only one store
                                                if (adminStoreIds.length === 1) return;

                                                setFormData(prev => ({
                                                    ...prev,
                                                    storeId: val?.[0]?.value || "",
                                                    storeName: val?.[0]?.label || "",

                                                }));
                                            }}
                                            loadStores={loadStores}
                                            loggedInRole={role}
                                            assignedStoreIds={adminStoreIds}
                                            isDisabled={adminStoreIds.length === 1}   // 🔥 KEY LINE
                                        />
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="phoneNumber" className="input-label">Mobile Number<span className="required">*</span></label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            placeholder="Enter Mobile Number"
                                            maxLength={10}
                                            title="Mobile Number must be exactly 10 digits"
                                            value={formData.phoneNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                }
                                            }}
                                        />
                                        {errors.phoneNumber && <p className="field-error">{errors.phoneNumber}</p>}
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="email" className="input-label">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            className="category-input"
                                            placeholder="Enter Email"
                                            value={formData.email || ""}
                                            onChange={handleEmailChange}
                                        />
                                        {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                                    </div>
                                </div>
                                <div className="customer-form-row">
                                    <div className="customer-form-group">
                                        <label htmlFor="age" className="input-label">
                                            Age
                                        </label>
                                        <input
                                            type="number"
                                            className="category-input"
                                            placeholder="Enter age"
                                            value={formData.age || ""}
                                            onChange={(e) => setFormData((prev) => ({ ...prev, age: e.target.value }))}
                                        />
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="gender" className="input-label">
                                            Gender<span className="required">*</span>
                                        </label>
                                        <select
                                            id="gender"
                                            className="category-input"
                                            value={formData.gender}
                                            onChange={(e) => {
                                                const selectedGenderType = e.target.value;

                                                setFormData((prev) => ({
                                                    ...prev,
                                                    gender: selectedGenderType
                                                }));

                                                // ✅ AUTO IMAGE BASED ON GENDER (ONLY IF USER HAS NOT UPLOADED IMAGE)
                                                if (!customerImage) {
                                                    if (selectedGenderType === "male") {
                                                        setPreviewUrl(maleImage);
                                                    } else if (selectedGenderType === "female") {
                                                        setPreviewUrl(femaleImage);
                                                    } else {
                                                        setPreviewUrl(defaultImage);
                                                    }
                                                }
                                            }}
                                        >
                                            <option value="">Select Gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="other">Other</option>
                                        </select>


                                        {errors.gender && <p className="field-error">{errors.gender}</p>}
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="city" className="input-label">
                                            City/Town
                                        </label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            value={formData.city || ""}
                                            placeholder="Enter City/Town"
                                            onChange={(e) => handleAlphabeticInput(e, "city")}
                                        />
                                        {cityError && <p style={{ color: "red" }}>{cityError}</p>}
                                    </div>
                                </div>
                                <div className="customer-form-row">
                                    <div className="customer-form-group">
                                        <label htmlFor="country" className="input-label">
                                            Country
                                        </label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            placeholder="Enter Country"
                                            value={formData.country || "India"}

                                            onChange={(e) => handleAlphabeticInput(e, "country")}
                                        />
                                        {countryError && <p style={{ color: "red" }}>{countryError}</p>}
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="state" className="input-label">
                                            State
                                        </label>
                                        <select className="category-input" value={formData.state || ""}
                                            onChange={(e) => setFormData(prev => ({ ...prev, state: e.target.value }))}
                                        >
                                            <option value="">Select State</option>

                                            {indianStates.map((state, index) => (
                                                <option key={index} value={state}>
                                                    {state}
                                                </option>
                                            ))}
                                        </select>
                                        {stateError && <p style={{ color: "red" }}>{stateError}</p>}
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="pincode" className="input-label">
                                            Pincode
                                        </label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            placeholder="Enter Pincode"
                                            value={formData.pincode || ""}
                                            onChange={handlePincodeInput}
                                            onBlur={handlePincodeBlur}
                                        />
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="aboutUs" className="input-label">
                                            Profession
                                        </label>
                                        <select
                                            className="category-input"
                                            name="customerSource"
                                            value={formData.aboutUs || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, aboutUs: e.target.value }))
                                            }
                                        >
                                            <option value="">Select Profession</option>
                                            <option value="Doctors">Doctors</option>
                                            <option value="Teachers">Teachers</option>
                                            <option value="IT">IT</option>
                                            <option value="Senior Citizens">Senior Citizens</option>
                                            <option value="Government officers">Government Officers</option>
                                            <option value="Lawyers">Lawyers</option>
                                        </select>

                                    </div>
                                    <div className="customer-form-group" style={{ flex: "1 1 100%" }}>
                                        <label htmlFor="customerNote" className="input-label">
                                            Customer Note
                                        </label>
                                        <textarea
                                            id="customerNote"
                                            rows={3}
                                            className="category-input"
                                            placeholder="Enter Customer Note"
                                            style={{ height: "auto", minHeight: "90px", resize: "vertical", paddingTop: "10px", fontSize: "14px" }}
                                            value={formData.customerNote || ""}
                                            onChange={(e) => setFormData(prev => ({ ...prev, customerNote: e.target.value }))}
                                        />
                                    </div>

                                </div>
                                <div className="customer-form-row">
                                    <div className="customer-form-group">
                                        <label htmlFor="dateOfBirth" className="input-label">
                                            Date of Birth
                                        </label>
                                        <input
                                            type="date"
                                            id="dateOfBirth"
                                            className="category-input"
                                            value={formData.dateOfBirth || ""}
                                            onChange={(e) => setFormData(prev => ({ ...prev, dateOfBirth: e.target.value }))}
                                        />
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="aniversaryDate" className="input-label">
                                            Anniversary Date
                                        </label>
                                        <input
                                            type="date"
                                            id="aniversaryDate"
                                            className="category-input"
                                            value={formData.aniversaryDate || ""}
                                            onChange={(e) => setFormData(prev => ({ ...prev, aniversaryDate: e.target.value }))}
                                        />
                                    </div>
                                </div>
                                <div className="customer-buttons">
                                    <button className="add-Product-button" type="submit" onClick={isAddCustomer ? handleAddCustomer : handleUpdateCustomer}>
                                        Add Customer
                                    </button>
                                    <button className="cancel-Product-button" onClick={() => navigate('/customers')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        /* ================= CUSTOMER LIST ================= */
                        <>
                            {/* ===== Header Section ===== */}
                            <Typography variant="h6">
                                Customers
                            </Typography>
                            <div className="customer-widgets">
                                <div className="widgets-left">
                                    <div className="search-input-wrapper">
                                        <input
                                            type="text"
                                            placeholder="Search customers..."
                                            className="customer-search-input"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <Icon icon="mdi:magnify" className="search-icon" />
                                    </div>
                                    {["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) && (
                                        <StoreSingleAllStoresSelect
                                            value={Store}
                                            onChange={(store) => setStore(store)}
                                        />
                                    )}
                                </div>
                                <div className="widgets-right desktop-only">
                                    <button className="add-Product-button" onClick={handleExportExcelCustomerData}>Export</button>
                                    <button className="add-Product-button" onClick={() => fileInputRef.current.click()}>Import</button>
                                    <button className="add-Product-button" onClick={() => navigate('/customers/add')}>+ Add Customer</button>
                                    <button className="add-Product-button template-btn" onClick={handleExportExcel}>Download Template</button>
                                </div>

                                <div className="widgets-right mobile-only">
                                    <button className="add-Product-button" onClick={() => navigate('/customers/add')}>+ Add Customer</button>

                                    <button
                                        className="add-Product-button dropdown-trigger"
                                        onClick={handleActionClick}
                                        style={{
                                            background: '#f8fafc',
                                            color: '#3C0008',
                                            border: '1px solid #3C0008',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px'
                                        }}
                                    >
                                        <Icon icon="mdi:tune" width="18" /> Actions
                                    </button>

                                    <Menu
                                        anchorEl={actionAnchorEl}
                                        open={isActionMenuOpen}
                                        onClose={handleActionClose}
                                        PaperProps={{
                                            sx: {
                                                borderRadius: '12px',
                                                mt: 1,
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                border: '1px solid #e2e8f0',
                                                '& .MuiMenuItem-root': {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem
                                            onClick={() => {
                                                handleActionClose();
                                                handleExportExcelCustomerData();
                                            }}
                                            sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                        >
                                            <Icon icon="mdi:export" style={{ fontSize: '18px', color: '#64748b' }} />
                                            Export
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handleActionClose();
                                                fileInputRef.current.click();
                                            }}
                                            sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                        >
                                            <Icon icon="mdi:import" style={{ fontSize: '18px', color: '#64748b' }} />
                                            Import
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handleActionClose();
                                                handleExportExcel();
                                            }}
                                            sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                        >
                                            <Icon icon="mdi:download" style={{ fontSize: '18px', color: '#64748b' }} />
                                            Download Template
                                        </MenuItem>
                                    </Menu>
                                </div>
                                <input
                                    type="file"
                                    accept=".xlsx, .xls"
                                    style={{ display: "none" }}
                                    ref={fileInputRef}
                                    onChange={handleBulkUploadClick}
                                />
                            </div>

                            {/* ===== TABLE ===== */}
                            <Box component={Paper}>
                                <TableContainer
                                    component={Paper}
                                    ref={tableContainerRef}
                                    sx={{
                                        maxHeight: 400,
                                        overflowY: "auto",
                                        '&::-webkit-scrollbar': { display: 'none' },
                                        scrollbarWidth: 'none',
                                        msOverflowStyle: 'none',
                                    }}
                                >
                                    <Table className="custom-product-table">
                                        <TableHead className="custom-product-head">
                                            <TableRow>
                                                {headings.map((heading, index) => {
                                                    const isCustomer = heading === "Customer Name";
                                                    const isEmail = heading === "Email";
                                                    const isMobileNumber = heading === "Mobile Number";
                                                    const sortKey = isCustomer
                                                        ? "name"
                                                        : isEmail
                                                            ? "email"
                                                            : isMobileNumber
                                                                ? "phoneNumber"
                                                                : null;
                                                    return (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border: "none",
                                                                padding: "12px 16px",
                                                                textAlign: "center",
                                                                position: "sticky",
                                                                top: 0,
                                                                zIndex: 0,
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "4px",
                                                                    color: "#ffffff",
                                                                    fontSize: "14px",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {heading}

                                                                {sortKey && (
                                                                    <span
                                                                        onClick={() => handleSort(sortKey)}
                                                                        style={{
                                                                            fontSize: "10px",
                                                                            color: "#fff",
                                                                            cursor: "pointer",
                                                                            marginLeft: "4px",
                                                                            userSelect: "none",
                                                                        }}
                                                                    >
                                                                        {sortField === sortKey
                                                                            ? sortOrder === 1
                                                                                ? "▲"
                                                                                : "▼"
                                                                            : "▲▼"}
                                                                    </span>
                                                                )}
                                                            </Typography>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {loading && customers.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={headings.length}>
                                                        <Typography sx={{ textAlign: 'center', padding: '20px', fontWeight: 500 }}>
                                                            Loading customers...
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : customers.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={headings.length}>
                                                        <Typography
                                                            sx={{
                                                                textAlign: 'center',
                                                                padding: '20px',
                                                                fontWeight: 500,
                                                            }}
                                                        >
                                                            No Customers found.
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                <>
                                                    {customers.map((customer, index) => (
                                                        <CustomerRow
                                                            key={customer._id}
                                                            customer={customer}
                                                            serialNo={isAllMode ? index + 1 : (currentPage - 1) * limit + index + 1}
                                                            canDelete={role !== "SelfAdmin"}
                                                            onView={handleViewCustomer}
                                                            onEdit={handleEditCustomer}
                                                            onDelete={handleOpen}
                                                        />
                                                    ))}
                                                    {isAllMode && (hasMoreCustomers || loadingMore) && (
                                                        <TableRow ref={loadMoreSentinelRef}>
                                                            <TableCell colSpan={headings.length}>
                                                                <Typography sx={{ textAlign: 'center', padding: '12px', fontSize: '13px', color: '#64748b' }}>
                                                                    {loadingMore ? "Loading more customers..." : "Scroll to load more"}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                {/* ===== FOOTER / PAGINATION ===== */}
                                <div className="product-bottom">
                                    <div className="product-section show-entries">
                                        <span className="text-label">Show</span>
                                        <select
                                            className="entries-select"
                                            value={limit}
                                            onChange={handleItemsPerPageChange}
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="all">All</option>
                                        </select>
                                        <span className="text-label">Entries</span>
                                    </div>

                                    <div className="product-section showing-range">
                                        {limit === 'all'
                                            ? `Showing ${customers.length} of ${totalCount} entries`
                                            : `Showing ${totalCount === 0 ? 0 : (currentPage - 1) * limit + 1} to ${Math.min(
                                                currentPage * limit,
                                                totalCount
                                            )} of ${totalCount} entries`
                                        }
                                    </div>

                                    <div className="product-section showing-counts" style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 14px', backgroundColor: '#FDF7F8', border: '1px solid #E5C3C8', borderRadius: '20px', boxShadow: '0px 2px 6px rgba(60, 0, 8, 0.05)' }}>
                                            <Icon icon="mdi:crown" style={{ color: '#3C0008', fontSize: '16px' }} />
                                            <span className="text-label" style={{ fontWeight: 700, color: '#3C0008', letterSpacing: '0.5px', fontSize: '12px' }}>
                                                VIP MEMBERS: <span style={{ fontSize: '14px', marginLeft: '2px' }}>{totalMembersCount}</span>
                                            </span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 14px', backgroundColor: '#F5F5F5', border: '1px solid #D2D2D2', borderRadius: '20px', boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.05)' }}>
                                            <Icon icon="mdi:account-group" style={{ color: '#525252', fontSize: '16px' }} />
                                            <span className="text-label" style={{ fontWeight: 700, color: '#525252', letterSpacing: '0.5px', fontSize: '12px' }}>
                                                STANDARD MEMBERS: <span style={{ fontSize: '14px', marginLeft: '2px' }}>{totalNonMembersCount}</span>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="product-section pagination-buttons">
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("first")}
                                        >
                                            <Icon icon="mdi:chevron-double-left" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("prev")}
                                        >
                                            <Icon icon="mdi:chevron-left" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("next")}
                                        >
                                            <Icon icon="mdi:chevron-right" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("last")}
                                        >
                                            <Icon icon="mdi:chevron-double-right" />
                                        </button>
                                    </div>
                                </div>
                            </Box>
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 380,
                                        background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                        borderRadius: "20px",
                                        boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                        p: 4,
                                        outline: "none",
                                        textAlign: "center",
                                        overflow: "hidden"
                                    }}
                                >
                                    {/* ✅ TOP ICON BADGE */}
                                    <Box
                                        sx={{
                                            width: 74,
                                            height: 74,
                                            borderRadius: "50%",
                                            background: "#3C0008",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto 16px auto",
                                            color: "#fff",
                                            fontSize: 30,

                                            boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                            animation: "deletePulse 1.6s infinite ease-in-out",

                                            "@keyframes deletePulse": {
                                                "0%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                },
                                                "70%": {
                                                    transform: "scale(1.1)",
                                                    boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                },
                                                "100%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                },
                                            },
                                        }}
                                    >
                                        🗑️
                                    </Box>


                                    {/* ✅ TITLE */}
                                    <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#2b2b2b",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Confirm Delete
                                    </Typography>

                                    {/* ✅ DESCRIPTION */}
                                    <Typography
                                        id="modal-modal-description"
                                        sx={{
                                            mt: 1.2,
                                            fontSize: 14,
                                            color: "#666",
                                            lineHeight: 1.6
                                        }}
                                    >
                                        Are you sure you want to delete this customer?
                                    </Typography>

                                    {/* ✅ BUTTON GROUP */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2.5,
                                            mt: 3.5
                                        }}
                                    >
                                        {/* ✅ DELETE BUTTON */}
                                        <Button
                                            variant="contained"
                                            onClick={handleDeleteCustomer}
                                            className="add-Product-button"
                                        >
                                            Yes, Delete
                                        </Button>

                                        {/* ✅ CANCEL BUTTON */}
                                        <Button
                                            variant="outlined"
                                            onClick={handleClose}
                                            className="cancel-Product-button"
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setPreviewUrl(null);
                                                setLoaderText('');
                                            }}
                                        />
                                        <div className="popup-form">
                                            <Typography variant="h6" textAlign="center" mb={4} sx={{ fontWeight: 500 }}>
                                                {isEditMode ? "Edit Customer" : "Add Customer"}
                                            </Typography>
                                            <form className="popup-form-body" onSubmit={handleUpdateCustomer}>

                                                {/* ===== ROW 1 ===== */}
                                                <div className="form-group-row">

                                                    {/* Name */}
                                                    <div className="form-group">
                                                        <label>Customer Name</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            value={formData.name}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                    {/* Store */}
                                                    <div className="form-group">
                                                        <label>Store Name</label>
                                                        <StoreMultiSelect
                                                            value={
                                                                formData.storeId
                                                                    ? (Array.isArray(formData.storeId)
                                                                        ? formData.storeId.map((id, i) => ({
                                                                            value: id,
                                                                            label: Array.isArray(formData.storeName) ? formData.storeName[i] : formData.storeName
                                                                        }))
                                                                        : [{ value: formData.storeId, label: formData.storeName }]
                                                                    )
                                                                    : []
                                                            }
                                                            onChange={(val) => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    storeId: val.map(v => v.value),
                                                                    storeName: val.map(v => v.label),
                                                                }));
                                                            }}
                                                            loadStores={loadStores}
                                                            loggedInRole={role}
                                                            assignedStoreIds={adminStoreIds}
                                                            onAddStore={() => setIsAddStore(true)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* ===== ROW 2 ===== */}
                                                <div className="form-group-row">

                                                    {/* Mobile */}
                                                    <div className="form-group">
                                                        <label>Mobile Number</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            maxLength={10}
                                                            value={formData.phoneNumber}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d{0,10}$/.test(value)) {
                                                                    setFormData(prev => ({ ...prev, phoneNumber: value }));
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Email */}
                                                    <div className="form-group">
                                                        <label>Email</label>
                                                        <input
                                                            type="email"
                                                            className="category-input"
                                                            value={formData.email}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, email: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                {/* ===== ROW 3 ===== */}
                                                <div className="form-group-row">

                                                    {/* Gender */}
                                                    <div className="form-group">
                                                        <label>Gender</label>
                                                        <select
                                                            className="category-input"
                                                            value={formData.gender}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, gender: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select Gender</option>
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                            <option value="other">Other</option>
                                                        </select>
                                                    </div>

                                                    {/* Age */}
                                                    <div className="form-group">
                                                        <label>Age</label>
                                                        <input
                                                            type="number"
                                                            className="category-input"
                                                            value={formData.age}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, age: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                {/* ===== ROW 4 ===== */}
                                                <div className="form-group-row">

                                                    {/* City */}
                                                    <div className="form-group">
                                                        <label>City</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            value={formData.city}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, city: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                    {/* State */}
                                                    <div className="form-group">
                                                        <label>State</label>
                                                        <select className="category-input" value={formData.state || ""}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, state: e.target.value }))}
                                                        >
                                                            <option value="">Select State</option>

                                                            {indianStates.map((state, index) => (
                                                                <option key={index} value={state}>
                                                                    {state}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* ===== ROW 5 ===== */}
                                                <div className="form-group-row">

                                                    {/* Country */}
                                                    <div className="form-group">
                                                        <label>Country</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            value={formData.country}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, country: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                    {/* Pincode */}
                                                    <div className="form-group">
                                                        <label>Pincode</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            maxLength={6}
                                                            value={formData.pincode}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, pincode: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                {/* ===== ROW 6 ===== */}
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label>Date of Birth</label>
                                                        <input
                                                            type="date"
                                                            className="category-input"
                                                            value={formData.dateOfBirth || ""}
                                                            onChange={e => setFormData(prev => ({ ...prev, dateOfBirth: e.target.value }))}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Anniversary Date</label>
                                                        <input
                                                            type="date"
                                                            className="category-input"
                                                            value={formData.aniversaryDate || ""}
                                                            onChange={e => setFormData(prev => ({ ...prev, aniversaryDate: e.target.value }))}
                                                        />
                                                    </div>
                                                </div>

                                                {/* ===== ROW 7 ===== */}
                                                <div className="form-group-row">
                                                    {/* About Us */}
                                                    <div className="form-group">
                                                        <label>Profession</label>
                                                        <select
                                                            className="category-input"
                                                            name="customerSource"
                                                            value={formData.aboutUs || ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, aboutUs: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select Profession</option>
                                                            <option value="Doctors">Doctors</option>
                                                            <option value="Teachers">Teachers</option>
                                                            <option value="IT">IT</option>
                                                            <option value="Senior Citizens">Senior Citizens</option>
                                                            <option value="Government officers">Government Officers</option>
                                                            <option value="Lawyers">Lawyers</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* ===== ROW 8: CUSTOMER NOTE ===== */}
                                                <div className="form-group-row">
                                                    <div className="form-group full-width" style={{ gridColumn: "span 2" }}>
                                                        <label htmlFor="customerNote">Customer Note</label>
                                                        <textarea
                                                            id="customerNote"
                                                            rows={3}
                                                            className="category-input"
                                                            placeholder="Enter Customer Note"
                                                            style={{ height: "auto", minHeight: "90px", resize: "vertical", paddingTop: "10px", fontSize: "14px" }}
                                                            value={formData.customerNote || ""}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, customerNote: e.target.value }))}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="customerImage">Customer Image</label>
                                                        <input
                                                            type="file"
                                                            id="customerImage"
                                                            accept="image/*"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                if (file && file.size > 1024 * 1024) {
                                                                    toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                                                    e.target.value = "";
                                                                    return;
                                                                }
                                                                if (file) {
                                                                    setCustomerImage(file);
                                                                    setPreviewUrl(URL.createObjectURL(file));
                                                                    setFileName(file.fileName);
                                                                }
                                                            }}
                                                        />
                                                        {previewUrl ? (
                                                            <div className="image-preview">
                                                                <img src={previewUrl} alt="Preview" />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>


                                                {/* ===== SUBMIT BUTTONS ===== */}
                                                <div className="form-actions">
                                                    <button type="submit" className="add-Product-button">
                                                        {isEditMode ? "Update Customer" : "Add Customer"}
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="cancel-Product-button"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </>
                    )}
                </main>
                <Footer />
            </div>
            {isAddStore && (
                <div className="popup-overlay">
                    <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                        <Icon
                            icon={closeIcon}
                            className="popup-close-icon-outside"
                            onClick={() => setIsAddStore(false)}
                        />
                        <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                            <AddStoreForm
                                onSuccess={() => {
                                    setIsAddStore(false);
                                    setStoreRefreshKey(prev => prev + 1);
                                }}
                                onCancel={() => setIsAddStore(false)}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

}

export default CustomerPage;